import { InputTitle } from 'components/input/InputTitle';
import CommonSelect from 'components/select/CustomSelect';
import { Button, Modal, Row, TextInput, Typography, useDialogStore } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';

import { StationModal } from '../styles/station-modal';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

import { COLOR } from 'constants/color';

import { useStationModalController } from '../core/controllers/station-modal';
import { StationSearchType } from '../core/enum';

export const AddStationModal = () => {
  const data = useDialogStore((s) => s.state.data);

  const id = data[MODAL_KEY.ADD_STATION]?.id;

  const {
    values,
    onCloseModal,
    handleChange,
    handleSubmit,
    handleFocus,
    // options,
    handleChangeInput,
    handleChangeOption,
    selectedOption,
    disabledButton,
    hideCloseIcon,
    // removeOptions,
    locationData,
    updateLocationData,
    onFocus,
  } = useStationModalController(id);

  const isEdit = Boolean(id);

  return (
    <StationModal>
      <Modal
        modalKey={MODAL_KEY.ADD_STATION}
        footer={
          <div
            style={{
              padding: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            {isEdit ? (
              <>
                <Button
                  variant="outlined"
                  type="submit"
                  size="medium"
                  style={{ fontSize: 18, lineHeight: '26px', fontWeight: 600, marginRight: 12 }}
                  onClick={onCloseModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ fontSize: 18, lineHeight: '26px', fontWeight: 600 }}
                  onClick={() => handleSubmit()}
                  disabled={disabledButton}
                >
                  Save
                </Button>
              </>
            ) : (
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{ fontSize: 18, lineHeight: '26px', fontWeight: 600 }}
                onClick={() => handleSubmit()}
                disabled={disabledButton}
              >
                Add
              </Button>
            )}
          </div>
        }
        header={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Typography
              style={{ fontSize: 22, lineHeight: '30px' }}
              weight={500}
              color={COLOR.surfaceNeutralBold['neutral-11']}
            >
              {isEdit ? 'Edit center' : 'Add center'}
            </Typography>
            {!hideCloseIcon && <CloseIcon onClick={onCloseModal} />}
          </div>
        }
        hideCloseIcon
        closeOnClickOutside={false}
      >
        <Row style={{ gap: 12 }}>
          <div style={{ width: '70%' }}>
            <Row direction="column" style={{ marginBottom: 24 }}>
              <InputTitle title="Center name" />
              <TextInput name="name" value={values.name} onChange={handleChange} />
            </Row>
          </div>
          <div style={{ width: '30%' }}>
            <Row direction="column" style={{ marginBottom: 24 }}>
              <InputTitle title="ID (4 characters)" />
              <TextInput
                name="stationId"
                value={values.stationId}
                onChange={handleChange}
                // disabled={isEdit}
                maxLength={4}
              />
            </Row>
          </div>
        </Row>

        <Row style={{ gap: 12 }}>
          <Row direction="column" style={{ marginBottom: 24 }}>
            <InputTitle title="Country" />

            <CommonSelect
              value={locationData.selectedCountry}
              options={locationData.countryOptions}
              onChange={(item) => updateLocationData('selectedCountry', item)}
              onInputChange={() => {}}
              controlStyle={{ width: '100%', background: 'white', borderRadius: 12 }}
            />
          </Row>
          <Row direction="column" style={{ marginBottom: 24 }}>
            <InputTitle title="State" />

            <CommonSelect
              disabled={!locationData.selectedCountry}
              value={locationData.selectedState}
              options={locationData.stateOptions}
              onChange={(item) => updateLocationData('selectedState', item)}
              onInputChange={() => {}}
              controlStyle={{ width: '100%', background: 'white', borderRadius: 12 }}
              onFocus={() => onFocus(StationSearchType.STATE)}
            />
          </Row>
        </Row>
        <Row style={{ gap: 12 }}>
          <Row direction="column" style={{ marginBottom: 24 }}>
            <InputTitle title="City" />

            <CommonSelect
              disabled={!locationData.selectedState}
              value={locationData.selectedCity}
              options={locationData.cityOptions}
              onChange={(item) => updateLocationData('selectedCity', item)}
              onInputChange={() => {}}
              controlStyle={{ width: '100%', background: 'white', borderRadius: 12 }}
              onFocus={() => onFocus(StationSearchType.CITY)}
            />
          </Row>
          <Row direction="column" style={{ marginBottom: 24 }}>
            <InputTitle title="Postal Code" />

            <TextInput
              name="postalCode"
              type="number"
              value={(values.postalCode as unknown as number) || ''}
              onChange={handleChange}
              style={{ width: '100%' }}
            />
          </Row>
        </Row>

        <Row direction="column" style={{ marginBottom: 24 }}>
          <InputTitle title="Address" />

          <TextInput name="address" value={values.address} onChange={handleChange} />
        </Row>
      </Modal>
    </StationModal>
  );
};
